import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import { resetPasswordValidator } from "../utils/validators/resetPassword";
import ResetPasswordForm from "./forms/ResetPasswordForm";

export default function ResetPasswordWidget() {
  const {
    actions: { resetPassword },
  } = useAuth();

  return (
    <Form
      onSubmit={resetPassword}
      validate={resetPasswordValidator}
      component={ResetPasswordForm}
    />
  );
}
